<template>
  <v-row
    :class="`elevation-6 px-4 mx-1 py-4 mb-4 ${inArray ? 'mt-4' : 'mt-n2'} white`"
    dense
  >
    <v-col v-if="listLabel" :cols="editable ? 6 : 10">
      <b>{{ listLabel }}</b>
      <v-icon
          v-if="enableResolvedCheckMark && resolved"
          dense
          color="success"
        >
          mdi-check
      </v-icon>
    </v-col>
    <v-col v-if="editable" cols="6">
      <v-btn
        @click.stop="editFunction"
        class="float-right"
        icon
        color="ternary"
      >
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </v-col>
    <v-col v-if="!editable && ((prefConflicts && prefConflicts.length > 0) || (optionList && optionList.length > 0))" cols="2">
      <v-menu offset-y max-height="600px" min-width="150px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="!lock && (optionList.length > 0 || prefConflicts)"
            class="float-right rai-btn-chevron"
            fab
            icon
            small
            dark
            color="grey"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark large>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in optionList"
            :key="index"
            @click="changeSelectedOption(item)"
            class="rai-scenario__block"
          >
            <v-list-item-title>
              {{ !showLogicalLanguage ? getName(item) || $t('global.notranslation') : getProlog(item) || $t('global.notranslation') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list
          v-if="prefConflicts && prefConflicts.length > 0"
        >
          <v-list-item
            v-for="(pref, index) in prefConflicts"
            :key="index"
            @click="changeSelectedPref(pref)"
            class="rai-scenario__block"
          >
            <v-list-item-title>
              <option-block
                :options="[ pref[wigoProperty] ]"
                :elements="pref.scenario.elements"
                :list-label="`${pref.id}`"
                :enableResolvedCheckMark="enableResolvedCheckMark"
                :resolved="defineResolvedFunction !== undefined ? defineResolvedFunction(pref) : pref.isCombinationResolved"
                :belief-mode="beliefMode"
              />
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <slot></slot>
    <v-col cols="12" v-if="!loading">
      <span
        v-if="options.length > 0"
      >
        <element-chip
          v-if="beliefMode"
          :element="options[0][0]"
        />
        <wigo-chip
          v-else
          v-for="wigo in options"
          :key="!!wigo.length ? wigo.map(opt => opt.id).join('-') : wigo.id"
          :wigo="!!wigo.length ? wigo : [wigo]"
          :asGroup="asGroup"
          :draggable="draggable"
          :close-function="closeFunction"
          :close="close && (wigo.isCloseable === undefined || wigo.isCloseable)"
        />
      </span>

      <v-chip
        v-for="(element, index) in elements"
        :key="'elt_' + index"
        color="secondary"
        class="px-5 pt-0 mr-1 my-1 black--text font-weight-bold"
      >
        {{ !showLogicalLanguage ? (element.name ? element.name : $t('global.notranslation')) : (element.prolog ? element.prolog : $t('global.notranslation')) }}
      </v-chip>
    </v-col>
    <v-col cols="12" v-else>
      <v-progress-circular
        size="35"
        width="5"
        class="d-block mx-auto"
        indeterminate
        color="primary"
      />
    </v-col>

  </v-row>
</template>

<script>
import WigoChip from '@/components/global/WigoChip';
import believeService from '@/services/believes.js';
import _ from 'lodash';
import ElementChip from './ElementChip.vue';

function sameId(o1, o2) {
  return  o1.id === o2.id;
}

export default {
  name: 'OptionBlock',

  components: { WigoChip, ElementChip },

  props: {
    prefConflicts: {
      type: Array,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    listLabel: {
      type: String,
      required: false
    },
    options: { // Wigos
      type: Array,
      required: true,
    },
    close: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    editFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    elements: {
      type: Array,
      required: false,
      default: () => [],
    },
    inArray: {
      type: Boolean,
      required: false,
      default: false,
    },
    optionList: { // all available options
      type: Array,
      required: false,
      default: () => [],
    },
    enableResolvedCheckMark: {
      type: Boolean,
      required: false,
      default: false
    },
    resolved: {
      type: Boolean,
      required: false,
      default: false
    },
    defineResolvedFunction: {
      type: Function,
      required: false,
      default: undefined,
    },
    lock: {
      type: Boolean,
      required: false,
      default: false
    },
    beliefMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    asGroup: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
    isArray () {
      return Array.isArray(this.options);
    },
    showLogicalLanguage () {
      return this.$store.state.showLogicalLangage;
    },
    wigoProperty() {
      return believeService.wigoProperty(this.beliefMode);
    },
  },

  methods: {

    changeSelectedOption (option) {
      this.$emit('changeOption', option);
    },

    changeSelectedPref (pref) {
      this.$emit('changePref', pref);
    },

    getName (item) {
      if( item.length ) {
        return item.map(i => i.name).join('/')
      } else {
        return item.name
      }
    },

    getProlog (item) {
      if( item.length ) {
        return item.map(i => i.prolog).join('/')
      } else {
        return item.prolog
      } 
    },

    mergeElements (pref1, pref2) {
      let array = [...pref1.scenario.elements, ...pref2.scenario.elements];
      array = _.uniqWith(array, sameId);
      return array;
    }
  },
};
</script>

<style>
.rai-btn-chevron {
  max-height: 24px;
  width: 25px;
}
</style>